import {useEffect, useRef, useState} from "react";
import axios from "axios";
import {friendlyErrorMessage} from "./format.js";

/**
 * Wie Components/Statistics/useStatisticsData.js, aber mit freundlicher
 * Meldung bei fehlendem Recht (403) statt der rohen Server-Antwort - die
 * Rechte je Unterseite greifen serverseitig (schnittstelle.md 7.1), die
 * Oberfläche darf dabei nie leer oder mit einer technischen Meldung
 * hängenbleiben.
 */
export default function useAnalysisData(url, params, {skip = false} = {}) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(!skip);
    const [error, setError] = useState(null);
    const abortRef = useRef(null);
    const signature = JSON.stringify(params || {});

    useEffect(() => {
        if (skip || !url) {
            return undefined;
        }

        const controller = new AbortController();
        abortRef.current?.abort();
        abortRef.current = controller;
        setLoading(true);
        setError(null);
        setData(null);

        axios
            .get(url, {params, signal: controller.signal})
            .then(({data: response}) => {
                setData(response);
            })
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return;
                }
                setError(friendlyErrorMessage(e, "Die Daten konnten nicht geladen werden."));
            })
            .finally(() => {
                if (abortRef.current === controller) {
                    setLoading(false);
                }
            });

        return () => controller.abort();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url, signature, skip]);

    return {data, loading, error};
}
